class CountdownTimerBar extends HTMLElement {
  connectedCallback() {
    this.hoursEl = this.querySelector("[data-hours]");
    this.minutesEl = this.querySelector("[data-minutes]");
    this.secondsEl = this.querySelector("[data-seconds]");
    this.expiredMessage = this.querySelector("[data-expired-message]");
    this.box = this.querySelector(".countdown-timer__box");

    if (!this.hoursEl || !this.minutesEl || !this.secondsEl) return;

    this.storageKey = "countdown-target";

    const savedTarget = Number(localStorage.getItem(this.storageKey));

    if (savedTarget && savedTarget > Date.now()) {
      this.targetDate = savedTarget;
    } else {
      this.resetTo24Hours();
    }

    this.update();
    this.interval = setInterval(() => this.update(), 1000);
  }

  resetTo24Hours() {
    this.targetDate = Date.now() + 24 * 60 * 60 * 1000;
    localStorage.setItem(this.storageKey, String(this.targetDate));
  }

  update() {
    let distance = this.targetDate - Date.now();

    if (distance <= 0) {
      this.resetTo24Hours();
      distance = this.targetDate - Date.now();
    }

    const totalSeconds = Math.floor(distance / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    this.hoursEl.textContent = String(hours).padStart(2, "0");
    this.minutesEl.textContent = String(minutes).padStart(2, "0");
    this.secondsEl.textContent = String(seconds).padStart(2, "0");

    if (this.box) this.box.hidden = false;
    if (this.expiredMessage) this.expiredMessage.hidden = true;
  }

  stopTimer() {
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null;
    }
  }

  disconnectedCallback() {
    this.stopTimer();
  }
}

if (!customElements.get("countdown-timer-bar")) {
  customElements.define("countdown-timer-bar", CountdownTimerBar);
}